import React from "react"

import './case-text.scss'

export const CaseText = ( { title, highlight, texts, last } ) => {
  const titleTag = title ? <h2 className="title">{ title }</h2> : null
  const highlightTag = highlight ? <div className="highlight">{ highlight }</div> : null
  const final = last ? "text-final" : "text"

  return (
    <div className="case-text">
      { titleTag }
      { highlightTag }
      {
        texts.map( ( text, idx ) => <p key={ "p-" +  idx } className={final}>{ text }</p> )
        }
    </div>
  )
}
